import { StepType } from '@reactour/tour';
// @ts-ignore
import ss from '@ukpostbox/frontend-framework/lib/Components/Navigation/SectionNavigation/SectionNavigation.module.scss';

export const mailboxTourSteps: Array<StepType> = [
	{
		selector: `.${ss['section-navigation']}`,
		content: (
			<div>
				<h6>Mailboxes</h6>
				<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
			</div>
		),
		position: 'top',
	},
	{
		selector: `.custom-folder-container`,
		content: (
			<div>
				<h6>Custom Folders</h6>
				<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
			</div>
		),
		position: 'right',
	},
	{
		selector: `.mailbox-item`,
		content: (
			<div>
				<h6>Mail Item</h6>
				<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
			</div>
		),
		position: 'right',
	},
];
